import { Cloudinary } from './config';
export default {
  readFile,
  uploadImg,
};
function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = (e) => resolve(reader.result);
    reader.readAsDataURL(file);
  });
}
async function uploadImg(img) {
  const { CLOUD_NAME, PRESET_NAME } = Cloudinary;

  const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    formData = new FormData();

  formData.append('file', img);
  formData.append('upload_preset', PRESET_NAME);
  const res = await fetch(UPLOAD_URL, {
    method: 'POST',
    body: formData,
  });
  const uploadedImg = await res.json();
  return uploadedImg.url;
}
